var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"items":[
    { text: 'Abernathy Ltd a' },
    { text: 'Alex Test School 002 (EN)' },
    { text: 'Alex Test School 003 (NL)' },
    { text: 'Bett English' } ],"label":_vm.$t('school.select'),"single-line":"","append-icon":"keyboard_arrow_down"}})}
var staticRenderFns = []

export { render, staticRenderFns }